































import Vue from 'vue';
import {IJourneyDetails} from "./JourneyDetails";
import {Component, Prop} from "vue-property-decorator";
import {IRefundStatusJourney} from "./IRefundStatusJourney";
import AppealsEmail from './AppealsEmail.vue';

@Component({
    components: {
        AppealsEmail
    }
})
export default class RefundUnavailable extends Vue {
    @Prop() details: IJourneyDetails;
    @Prop() refundData: IRefundStatusJourney;
    @Prop() appealsEmail: string;
    @Prop() dryRunError: string;

    mounted() {
        const titleParts = document.title.split(" - ");
        titleParts[0] = "Refund Unavailable";
        document.title = titleParts.join(" - ");
    }

    get isNrcotChange() {
      return this.dryRunError && this.dryRunError.indexOf('From 1st April 2026') !== -1;
    }

    errorReason() {
        // Email -> Nick, 9 Nov
        const availableRefund = this.refundData.ticketsRefundValue - this.refundData.adminFee;
        const availableReplacement = this.refundData.ticketsReplaceValue - this.refundData.adminFeeReplacement;

        if (this.refundData.isCancelled) {
            return "it looks like you've already received a refund";
        } else if (this.refundData.isScanned) {
            return "our records indicate you may have already used this ticket";
        }

        if (this.isNrcotChange) {
            return "National Rail refund rules changed on 1st April 2026, and walk-up ticket refunds must now be requested by 23:59 the night before the first date of validity";
        }

        if (availableRefund <= 0 && availableReplacement <= 0) {
            return "no refund is available"; // Email -> Nick, 19 Sep
        }

        // If none of the above cases are true, but there's no balance, it's almost certainly because a promo-code
        // was applied that discounted 100% of the purchase cost
        if (this.refundData.balance == 0) {
            return "there is no balance to refund";
        }

        return "something went wrong";
    }
}

